goog.provide("shadow.js.shim.module$src$svg$arrows$arrow_left_svg$default");
shadow.js.shim.module$src$svg$arrows$arrow_left_svg$default = shadow.js.shim.module$src$svg$arrows$arrow_left_svg.default;
